





import { Component, Prop, Vue } from "vue-property-decorator";
const { DateTime } = require("luxon");

@Component
export default class NullableField extends Vue {
  @Prop({ required: true }) readonly value!: string | null;
  @Prop({ default: "string" }) readonly type!: string;

  datetimeString(datetime: string): string {
    return DateTime.fromISO(datetime).toLocaleString(DateTime.DATETIME_MED);
  }

  get displayValue(): string {
    if (this.value === null) {
      return "";
    }

    if (this.type === "datetime") {
      return this.datetimeString(this.value);
    } else {
      return this.value;
    }
  }
}
